/* eslint-disable react/button-has-type */
/* eslint-disable no-restricted-globals */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */

import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import uuid from 'react-uuid';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { distributorService } from '../../../../service/distributor.service';
import { FilterPayloadConstruction } from '../../../../redux/helper/FIlterPayloadConstructor';
import { DistributorActions } from '../../../../redux/actions';
import ProductListSkeleton from './ProductListSkeleton';
import ProductList from './ProductList';
import Pagination from '../../../../Components/Pagination';
import { CDN } from '../../../../constants';

const sortValues = [{
    id: 1,
    name: 'Producr Code',
    label: 'Producr Code',
    value: 'CONCATENATED_SEGMENTS asc',
},
{
    id: 2,
    name: 'Expected Dispatch Date',
    label: 'Dispatch Date',
    value: 'EXPECTED_DELIVERY_DATE asc',
},
{
    id: 3,
    name: 'MOQ: Low to high',
    label: 'MOQ: Low to high',
    value: 'MINIMUM_ORDER_QUANTITY asc',
},
{
    id: 4,
    name: 'MOQ: High to low',
    label: 'MOQ: High to low',
    value: 'MINIMUM_ORDER_QUANTITY desc',
},
{
    id: 5,
    name: 'List Price: Low to high',
    label: 'List Price: Low to high',
    value: 'LIST_PRICE asc',
},
{
    id: 6,
    name: 'List Price: High to low',
    label: 'List Price: High to low',
    value: 'LIST_PRICE desc',
}];

function ProductsListing({
    FilterData,
    handleIsExist,
    handleSelect,
    Products,
    GetProductList,
}) {
    const navigate = useNavigate();
    const { orderId, distributorId } = useParams();
    const [OrderDetails, setOrderDetails] = useState({});
    const [ThreelPl, setThreelPl] = useState([]);
    const [distributorDetails, setdistributorDetails] = useState({});
    const [addressDropdown, setaddressDropdown] = useState({});
    const [defaultAddress, setdefaulltAddress] = useState({});
    const [ThreePlPopup, setThreePlPopup] = useState('');
    const [UserRole, setUserRole] = useState('');
    const [loading, setloading] = useState(true);
    const [result, setresult] = useState([]);
    const [mainCategories, setmainCategories] = useState([]);
    const [Segments, setSegments] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [Filters, setFilters] = useState({});
    const [checkBox, setcheckBox] = useState([]);
    const [clearLoader, setClearLoader] = useState(false);
    const [sizeList, setSizeList] = useState([]);
    const [lengthList, setLengthList] = useState([]);
    const [currentCategory, setCurrentCategory] = useState({});
    const [uniqCount, setuniqCount] = useState({});
    const [InitialLoad, setInitialLoad] = useState(true);
    const [Cart, setCart] = useState([]);
    const [disableGotoCart, setDisableGotoCart] = useState(false);
    const [priceRange, setpriceRange] = useState({
        minValue: 0,
        maxValue: 0,
    });
    const [Size, setSize] = useState({
        LENGTH: '',
        DIAMETER: '',
    });
    const [toggles, settoggles] = useState({
        sort: false,
    });
    const initialState = {
        page: 1,
        limit: 10,
        distributor_id: distributorId,
        request: 'admin',
    };
    const [payload, setpayload] = useState(initialState);
    const handlePageClick = (data) => {
        // setInitialLoad(true);
        const page = data.selected + 1;
        setcurrentPage(page);
        setpayload((prv) => ({
            ...prv,
            page,
        }));
        payload.page = page;
        handleFetchProduct(payload);
    };

    const get3pl = useCallback(
        async () => {
            if (ThreePlPopup === '') {
                const response = await distributorService.getNewthreepl();
                if (!response.error) {
                    setThreelPl(response.data.data);
                    // setYesUpdate(!YesUpdate);
                }
            }
        },
        [],
    );

    const handleshipbilladdress = (addressList) => {
        const shipping_address = [];
        const billing_address = [];
        if (addressList.length > 0) {
            addressList.map((item, i) => {
                const unique_id = uuid();
                if (item.SITE_USE_CODE === 'BILL_TO') {
                    if (item.PRIMARY_FLAG === 'Y') { defaultAddress.billing_address = item; }
                    item.unique_id = `${unique_id}-${i}`;
                    billing_address.push(item);
                } else {
                    if (item.PRIMARY_FLAG === 'Y') { defaultAddress.shipping_address = item; }
                    item.unique_id = `${unique_id}-${i}`;
                    shipping_address.push(item);
                }
            });
        }
        setdefaulltAddress(defaultAddress);
        setaddressDropdown({
            shipping_address,
            billing_address,
        });
        return {
            shipping_address, billing_address,
        };
    };

    const getAddresList = (id) => {
        distributorService.getDistributorDetail(id).then((res) => {
            if (!res.error && res.data.success_status) {
                setdistributorDetails(res?.data?.data);
                distributorService.getDistributorAddress(res?.data?.data.CUST_ACCOUNT_ID).then((res1) => {
                    if (!res1.error && res1.data.success_status) {
                        handleshipbilladdress(res1?.data?.data);
                    }
                });
            }
        });
    };

    // const handleErrorMessage = (message, key) => {
    //     SetErrorMessage(message || 'Something went wrong');
    //     setcolorValue(true);
    //     setTimeout(() => {
    //         SetErrorMessage('');
    //         setcolorValue(false);
    //     }, 1500);
    // };
    const handleToggle = (key) => {
        settoggles((state) => ({
            ...state,
            [key]: !toggles[key],
        }));
    };

    const handlePayload = useCallback((key, value) => {
        if (key === 'PRICE_RANGE') {
            setpayload((state) => ({
                ...state,
                PRICE_RANGE: [value.minValue, value.maxValue],
                page: 1,
            }));
            payload.PRICE_RANGE = [value.minValue, value.maxValue];
        } else {
            setpayload((state) => ({
                ...state,
                [key]: value,
                page: 1,
            }));
            payload[key] = value;
        }
        handleToggle(key);
        if (key !== 'search') {
            setInitialLoad(true);
        }
        payload.page = 1;
        setcurrentPage(1);
        handleFetchProduct(payload);
    }, [payload]);

    const handleFetchProduct = useCallback((async (payloadCopy) => {
        settoggles((state) => ({
            ...state,
            sort: false,
        }));
        if (!payload.search) {
            // setInitialLoad(true)
        }
        GetProductList(payloadCopy);
        setTimeout(() => {
            window.scrollTo(0, 0);
            setInitialLoad(false);
        }, 2000);
    }), []);

    useEffect(() => {
        if (Object.keys(FilterData).length > 0) {
            setSegments(FilterData.filters);
        }
    }, [FilterData]);

    const handleApply = (clear, price) => {
        let payloadCopy = { ...payload };
        setInitialLoad(false);
        if (clear) {
            payloadCopy = { ...initialState };
            payloadCopy.category = [OrderDetails.initial_category.toUpperCase()];
            if (payloadCopy.category[0] === 'EQUIPMENTS') {
                payloadCopy.category[0] = 'EQUIPMENT';
            }
            if (payloadCopy.category[0] === 'MNR') {
                payloadCopy.category[0] = 'MnR';
            }
            setresult(transform(currentCategory, '', 1));
        } else {
            payloadCopy.PRICE_RANGE = undefined;
            if (Size?.DIAMETER !== '') {
                payloadCopy.DIAMETER = Size.DIAMETER;
            } else {
                payloadCopy.DIAMETER = undefined;
            }
            if (Size?.LENGTH !== '') {
                payloadCopy.LENGTH = Size.LENGTH;
            } else {
                payloadCopy.LENGTH = undefined;
            }
            if (priceRange.minValue > -1 && priceRange.maxValue > 0) {
                payloadCopy.PRICE_RANGE = [priceRange.minValue, priceRange.maxValue];
            }
            if (price?.min > -1 && price?.max > 0) {
                payloadCopy.PRICE_RANGE = [String(price.min), String(price.max)];
            }
            payloadCopy.page = 1;
            payloadCopy.category = FilterPayloadConstruction(result);
        }
        if (payloadCopy?.category.length === 0) {
            payloadCopy.category = [OrderDetails.initial_category.toUpperCase()];
            if (payloadCopy.category[0] === 'EQUIPMENTS') {
                payloadCopy.category[0] = 'EQUIPMENT';
            }
            if (payloadCopy.category[0] === 'MNR') {
                payloadCopy.category[0] = 'MnR';
            }
        }
        setcurrentPage(1);
        setpayload(payloadCopy);
        handleFetchProduct(payloadCopy);
        // handleFiltersData({checknoxValue:result,segments:Segments})
        setInitialLoad(true);
    };

    const findSegmnet = (obj, searchKey, arr) => {
        for (const property in obj) {
            if (obj.hasOwnProperty(property)) {
                if (Object.keys(obj[property]).length > 0 && property !== '' && property !== 'concatenated_segment') {
                    if (obj[property].concatenated_segment.split('.').includes(searchKey)) {
                        if (!arr.includes(obj[property].concatenated_segment)) {
                            arr.push(obj[property].concatenated_segment);
                        }
                    }
                    findSegmnet(obj[property], searchKey, arr);
                } else if (obj.concatenated_segment.split('.').includes(searchKey)) {
                    if (!arr.includes(obj[property].concatenated_segment)) {
                        arr.push(obj[property].concatenated_segment);
                    }
                }
            }
        }
        return arr;
    };

    const handleCheckBox = (item, segments) => {
        let copy = [];
        if (segments) {
            copy = [...Segments];
        } else {
            copy = [...checkBox];
        }
        let keyval = item;
        if (copy.includes(item)) {
            keyval = item.split('.')[item.split('.').length - 1];
            const parentKeyValue = item.split('.')[item.split('.').length - 2];
            let idx;
            const Duplicates = [];
            copy.map((val, i) => {
                if (val?.split('.').includes(keyval)) {
                    Duplicates.push(copy.indexOf(val));
                }
            });
            if (Duplicates.length > 1) {
                idx = Duplicates[Duplicates.length - 1];
            } else {
                idx = copy.indexOf(item);
            }
            copy.splice(idx, 1);
            const removeArr = [];
            copy.map((val) => {
                if (!val?.split('.').includes(keyval)) {
                    removeArr.push(val);
                }
            });
            let parentCount = 0;
            copy.map((val) => {
                if (val?.split('.').includes(parentKeyValue)) {
                    parentCount += 1;
                }
            });
            copy = removeArr;
        } else {
            if (item.split('.').length === 0) {
                copy.push(item);
            } else {
                let temp = '';
                item.split('.').map((val, i) => {
                    temp += i === 0 ? `${val}` : `.${val}`;
                    if (!copy.includes(temp)) {
                        copy.push(temp);
                    }
                });
                keyval = item.split('.')[item.split('.').length - 1];
            }
            if (segments === undefined) {
                findSegmnet(Filters, keyval, copy);
            }
        }
        if (segments) {
            setSegments(copy);
            // handleCheckboxSegments(keyval?.split('.')[0],item,copy);
        } else {
            setcheckBox(copy);
        }
    };

    function transform(object, newid, id1) {
        if (Object.keys(object).length > 0) {
            return Object
                .entries(object).filter(([keyVal, value]) => value !== '' && keyVal !== '')
                .map(([name, value]) => {
                    if (value.hasOwnProperty('')) {
                        Object.keys(value).map((key) => key === '' && delete value[key]);
                    }
                    if (value !== '') {
                        return {
                            name,
                            ...(value && typeof value === 'object' && !value.hasOwnProperty('')
                                ? {
                                    newid: `${id1++}-${name}`,
                                    id: `${newid === '' ? '' : `${newid}.`}${name}`,
                                    items:
                                    transform(value, `${newid === '' ? '' : `${newid}.`}${name}`, Object.keys(object).length),
                                }
                                : { newid: `${id1++}-${name}`, id: `${newid === '' ? '' : `${newid}.`}${name}` }),
                        };
                    }
                });
        }
    }

    const handleFetchFilters = useCallback(((category) => {
        if (category === 'Equipments') {
            category = 'Equipment';
        }
        distributorService.GetProductsFiters(category, `?distributor_id=${distributorId}`).then((res) => {
            if (res.data.success_status) {
                const data = transform(res.data.data, '', 1);
                setCurrentCategory(res.data.data);
                const lengthFilter = res.data.length.filter(({ LENGTH }) => LENGTH !== null && !isNaN(LENGTH));
                const sizeFilter = res.data.size.filter(({ DIAMETER }) => DIAMETER !== null && !isNaN(DIAMETER));
                setLengthList(lengthFilter);
                setSizeList(sizeFilter);
                setresult(data);
                setmainCategories(Object.keys((res.data.data)));
            }
        });
    }), []);

    const handleClear = () => {
        setSegments([]);
        setSize({
            LENGTH: '',
            DIAMETER: '',
        });
        setpriceRange((state) => ({
            ...state,
            maxValue: 0,
            minValue: 0,
        }));
        setresult([]);
        setClearLoader(true);
        // handleFetchFilters(OrderDetails?.initial_category);
        setcheckBox([]);
        handleApply('clear');
    };

    const handleFetch = useCallback(
        async () => {
            const details = await distributorService.ViewOrderDetails(orderId, distributorId);
            if (!details.error && details.data.success_status) {
                setOrderDetails(details.data.data);
                if (Object.keys(details.data.data?.items).length === 0) {
                    setDisableGotoCart(true);
                } else {
                    setDisableGotoCart(false);
                }
            } else {
                // handleErrorMessage(details?.data.message);
                setloading(false);
            }
        },
        [orderId],
    );

    const handleFetchOrder = useCallback(
        async () => {
            const details = await distributorService.ViewOrderDetails(orderId, distributorId);
            if (!details.error && details.data.success_status) {
                getAddresList(details?.data?.data?.distributor_id);
                setOrderDetails(details.data.data);
                if (Object.keys(details.data.data?.items).length === 0) {
                    setDisableGotoCart(true);
                } else {
                    setDisableGotoCart(false);
                }
                get3pl();
                payload.category = [details?.data?.data.initial_category.toUpperCase()];
                if (payload.category[0] === 'EQUIPMENTS') {
                    payload.category[0] = 'EQUIPMENT';
                } else if (payload.category[0] === 'MNR') {
                    payload.category[0] = 'MnR';
                }
                setpayload(payload);
                const productPayload = payload;
                productPayload.distributor_categories = true;
                GetProductList(productPayload);
                handleFetchFilters(details?.data?.data.initial_category);
                const current = JSON.parse(localStorage.getItem('user')).profile.roles;
                setUserRole(current);
                setloading(false);
                setTimeout(() => {
                    window.scrollTo(0, 0);
                    setInitialLoad(false);
                }, 2000);
            } else {
                // handleErrorMessage(details?.data.message);
                setloading(false);
            }
        },
        [orderId],
    );

    const handleNavigate = () => {
        navigate(`/manage-orders/direct-order/${distributorId}/${orderId}/edit/cart`);
    };

    useEffect(() => {
        handleFetchOrder();
    }, [handleFetchOrder]);

    return (
        <>
            <div className="flex justify-between items-center mx-[18px] sticky top-[94px] z-[99] bg-[#fff]">
                <div className="flex items-center">
                    <Link to="/manage-orders">
                        <img src="/images/Icon-feather-arrow-left-gray.svg" alt="icon" loading="lazy" decoding="async" />
                    </Link>
                    <h1
                        className="text-sm27 font-semibold text-[#555259] ml-2 "
                        style={{
                            fontWeight: '500px',
                            fontSize: '22px',
                            lineHeight: '28px',
                        }}

                    >
                        Create
                        {' '}
                        {OrderDetails?.order_type}
                        {' '}
                        Order

                    </h1>
                </div>
                <div className="flex justify-between items-center mx-[18px] ">
                    <button
                        onClick={() => handleNavigate()}
                        type="button"
                        className=" sm:h-10 h-8 px-10 mt-3 rounded-lg bg-[#555259] text-sm font-semibold text-[#FFFFFF] pt-[9px] disabled:bg-[#EAEAF0] pb-[9px]"
                        disabled={disableGotoCart}
                    >

                        Go to Cart
                        {` ${OrderDetails?.total_items ? `(${OrderDetails?.total_items})` : ''} `}
                    </button>
                </div>
            </div>
            <div className="sticky top-[146px] border-b border-[#EBEBEB] bg-[#fff] z-[9] pb-[8px]">
                <img style={{ borderRadius: '50%', objectFit: 'cover' }} src={OrderDetails?.distributor_info?.profile_image_url !== '' && OrderDetails?.distributor_info?.profile_image_url !== undefined ? (`${CDN}/${OrderDetails?.distributor_info?.profile_image_url}`) : '/images/pp.svg'} className="cursor-pointer w-[70px] h-[70px]" alt="icon" />
                <p className="absolute text-sm28 font-semibold top-[18px] left-[100px]">
                    {' '}
                    {OrderDetails?.distributor_info?.PARTY_NAME}
                </p>
                <p className="absolute text-sm29 text-[#555259] font-normal top-[50px] left-[100px]">
                    {' '}
                    {distributorId}
                    {' '}
                </p>
            </div>
            <div>
                <div class="lg:px-[18px] md:px-[46px] px-4 pt-[18px] pb-10">
                    <div class="w-full">
                        {/* <!-- product list and info section --> */}
                        <div>
                            {Object.keys(Products).length > 0
                                ? (
                                    <>
                                        <ProductList
                                            Products={Products.list}
                                            payload={payload}
                                            handleToggle={handleToggle}
                                            toggles={toggles}
                                            handlePayload={handlePayload}
                                            setpriceRange={setpriceRange}
                                            priceRange={priceRange}
                                            setSize={setSize}
                                            Size={Size}
                                            handleApply={handleApply}
                                            Filters={Filters}
                                            Segments={Segments}
                                            handleCheckBox={handleCheckBox}
                                            checkBox={checkBox}
                                            handleClear={handleClear}
                                            uniqCount={uniqCount}
                                            STOCK_VISIBILITY={Products.STOCK_VISIBILITY}
                                            handlefetch={handleFetch}
                                            result={result}
                                            Cart={Cart?.items}
                                            OrderDetails={OrderDetails}
                                            sizeList={sizeList}
                                            lengthList={lengthList}
                                            defaultAddress={defaultAddress}
                                            clearLoader={clearLoader}
                                            setClearLoader={setClearLoader}
                                        />
                                        { Products && Object.keys(Products).length > 0 && Products?.list?.length > 1 && (
                                            <Pagination
                                                handlePageClick={handlePageClick}
                                                List={Products}
                                                currentPage={currentPage}
                                            />
                                        )}

                                    </>
                                )
                                : <ProductListSkeleton /> }
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- modal for filter responsive --> */}
            <div className="modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto" id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[441px] mx-auto px-2.5">
                    <div
                        className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                    >
                        <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                            <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                                Filter
                            </h5>
                            <button
                                type="button"
                                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body relative sm:px-9 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                            <div className="flex items-start">
                                <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[25%]" id="pills-tabVertical" role="tablist">
                                    <li className="nav-item flex-grow mb-4" role="presentation">
                                        <a
                                            href="#pills-pricetab"
                                            className="nav-link block sm:text-base text-sm font-semibold text-[#090406] price active relative"
                                            id="pills-priceranje"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-pricetab"
                                            role="tab"
                                            aria-controls="pills-price"
                                            aria-selected="true"
                                        >
                                            Price range
                                        </a>
                                    </li>
                                    <li className="nav-item flex-grow text-center my-4 " role="presentation">
                                        <a
                                            href="#pills-profileVertical"
                                            className="nav-link block sm:text-base text-sm font-semibold text-[#090406] price relative"
                                            id="pills-size"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-sizemm"
                                            role="tab"
                                            aria-controls="pills-sizemm"
                                            aria-selected="false"
                                        >
                                            Size(mm)
                                        </a>
                                    </li>
                                    <li className="nav-item flex-grow text-center my-4" role="presentation">
                                        <a
                                            href="#pills-profileVertical"
                                            className="nav-link block sm:text-base text-sm font-semibold text-[#090406] price relative"
                                            id="pills-categories"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pillcategorie"
                                            role="tab"
                                            aria-controls="pillcategorie"
                                            aria-selected="false"
                                        >
                                            Categories
                                        </a>
                                    </li>
                                </ul>
                                <div className="tab-content w-[75%] h-[300px] bg-[#F2F2F3]" id="pills-tabContentVertical">
                                    <div className="tab-pane fade show active px-3 pt-4" id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                        <div className="relative">
                                            <div className="pt-3.5 flex justify-between">
                                                <p className="text-xs font-semibold text-[#000000]">₹ 5,000</p>
                                                <p className="text-xs font-semibold text-[#000000]">₹ 50,000</p>
                                            </div>
                                            <div className=" mt-3 mb-4">
                                                <div className="flex justify-center items-center">
                                                    <div x-data="range()" x-init="mintrigger(); maxtrigger()" className="relative max-w-xl w-full">
                                                        {/* <div>
                                                            <input type="range" step="100" x-bind:min="min" x-bind:max="max" x-on:input="mintrigger" x-model="minprice" className="absolute pointer-events-none appearance-none z-20 h-2 w-full opacity-0 cursor-pointer" />
                                                            <input type="range" step="100" x-bind:min="min" x-bind:max="max" x-on:input="maxtrigger" x-model="maxprice" className="absolute pointer-events-none appearance-none z-20 h-2 w-full opacity-0 cursor-pointer" />
                                                            <div className="relative z-10 h-2">
                                                                <div className="absolute z-10 left-0 right-0 bottom-0 top-0 rounded-md bg-gray-200" />
                                                                <div className="absolute z-20 top-0 bottom-0 rounded-md bg-[#555259]" x-bind:style="'right:'+maxthumb+'%; left:'+minthumb+'%'" />
                                                                <div className="absolute z-30 w-6 h-6 top-0 left-0 bg-[white] border-4 border-[#555259] rounded-full -mt-2" x-bind:style="'left: '+minthumb+'%'" />
                                                                <div className="absolute z-30 w-6 h-6 top-0 right-0 bg-[white] border-4 border-[#555259] rounded-full -mt-2" x-bind:style="'right: '+maxthumb+'%'" />
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="px-1 flex items-center">
                                            <div className="relative w-1/2">
                                                <input type="text" id="" className="bg-[#FFFFFF] w-full rounded border border-[#A5A5A5] outline-0 py-1 px-1.5 text-xs6 font-semibold text-[#000000] text-end" />
                                                <p className="text-xs6 font-semibold text-[#000000] absolute top-[5px] left-[5px] bg-[#FFFFFF]">₹</p>
                                            </div>
                                            <span className="text-xs6 font-semibold text-[#000000] px-5">-</span>
                                            <div className="relative w-1/2">
                                                <input type="text" id="" className="bg-[#FFFFFF] w-full rounded border border-[#A5A5A5] outline-0 py-1 px-1.5 text-xs6 font-semibold text-[#000000] text-end" />
                                                <p className="text-xs6 font-semibold text-[#000000] absolute top-[5px] left-[5px] bg-[#FFFFFF]">₹</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-pane fade px-3 pt-4" id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                        <div className="flex flex-col items-start px-2.5">
                                            <label htmlFor="Diameter" className="text-xs3 font-normal text-[#555259] pb-1.5">Diameter</label>
                                            <input type="text" id="Diameter" className="border border-[#A5A5A5] rounded-md px-2.5 py-1.5 text-xs font-normal text-[#090406] outline-0" />
                                        </div>
                                        <div className="flex flex-col items-start px-2.5 pt-3.5">
                                            <label htmlFor="length" className="text-xs3 font-normal text-[#555259] pb-1.5">Length</label>
                                            <input type="text" id="length" className="border border-[#A5A5A5] rounded-md px-2.5 py-1.5 text-xs font-normal text-[#090406] outline-0 placeholder:text-xs placeholder:font-normal placeholder:text-[#A5A5A5]" placeholder="Enter Length in mm" />
                                        </div>
                                    </div>
                                    <div className="tab-pane fade px-3" id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                        <div className="h-[270px] overflow-auto mt-[16px] sidebar">
                                            <button className="transition duration-150 ease-in-out flex items-center drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat1" aria-expanded="false" aria-controls="collapsecat1">
                                                <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                                    <input type="checkbox" id="ab1" checked="" />
                                                    <label htmlFor="ab1" className="consumbales pl-3 text-xs2 font-bold text-[#555259]">Consumables</label>
                                                </div>
                                                <img src="images/Arrow_down.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                            </button>
                                            <div className="collapse show pl-6 pt-3 relative categories flex flex-col" id="collapsecat1">
                                                <button className="flex items-center transition duration-150 ease-in-out drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat2" aria-expanded="false" aria-controls="collapsecat2">
                                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                        <input type="checkbox" id="ab2" checked="" />
                                                        <label htmlFor="ab2" className="consumbales pl-3 text-xs2 font-bold text-[#090406]">Welding Electrodes</label>
                                                    </div>
                                                    <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                                </button>
                                                <div className="collapse show pl-6 pt-3 relative categories" id="collapsecat2">
                                                    <button className="flex items-center transition duration-150 ease-in-out drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat3" aria-expanded="false" aria-controls="collapsecat3">
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                            <input type="checkbox" id="ab3" />
                                                            <label htmlFor="ab3" className="consumbales pl-3 text-xs2 font-normal text-[#808285]">C-Mn Steels</label>
                                                        </div>
                                                        <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                                    </button>
                                                    <button className="flex items-center transition duration-150 ease-in-out drop-rotate pt-3" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat4" aria-expanded="false" aria-controls="collapsecat4">
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                            <input type="checkbox" id="ab4" checked="" />
                                                            <label htmlFor="ab4" className="consumbales pl-3 text-xs2 font-normal text-[#555259]">Hardfacing</label>
                                                        </div>
                                                        <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                                    </button>
                                                    <div className="collapse show pl-6 pt-3 relative categories" id="collapsecat4">
                                                        <li className="list-none">
                                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                                <input type="checkbox" id="ab5" />
                                                                <label htmlFor="ab5" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Abrasion - Corrosion</label>
                                                            </div>
                                                        </li>
                                                        <li className="list-none pt-3">
                                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                                <input type="checkbox" id="ab6" />
                                                                <label htmlFor="ab6" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Build up</label>
                                                            </div>
                                                        </li>
                                                        <li className="list-none pt-3">
                                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                                <input type="checkbox" id="ab7" />
                                                                <label htmlFor="ab7" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">High Abrasion</label>
                                                            </div>
                                                        </li>
                                                        <li className="list-none pt-3">
                                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                                <input type="checkbox" id="ab8" />
                                                                <label htmlFor="ab8" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">High Impact - Corrosion Resistance</label>
                                                            </div>
                                                        </li>
                                                        <li className="list-none pt-3">
                                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                                <input type="checkbox" id="ab9" checked="" />
                                                                <label htmlFor="ab9" className="consumbales pl-3 text-xs2 font-bold text-[#555259] text-left">High Temperature Oxidation - Impact - Abrasion</label>
                                                            </div>
                                                        </li>
                                                        <li className="list-none pt-3">
                                                            <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                                <input type="checkbox" id="ab10" />
                                                                <label htmlFor="ab10" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Moderate - Abrasion Impact</label>
                                                            </div>
                                                        </li>
                                                    </div>
                                                    <button className="flex items-center transition duration-150 ease-in-out drop-rotate pt-3" type="button" data-bs-toggle="collapse" data-bs-target="#" aria-expanded="false" aria-controls="">
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                            <input type="checkbox" id="ab11" />
                                                            <label htmlFor="ab11" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Low Alloy Steel</label>
                                                        </div>
                                                        <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                                    </button>
                                                    <button className="flex items-center transition duration-150 ease-in-out drop-rotate pt-3" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat5" aria-expanded="false" aria-controls="collapsecat5">
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                            <input type="checkbox" id="ab12" />
                                                            <label htmlFor="ab12" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Non Ferrous</label>
                                                        </div>
                                                        <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                                    </button>
                                                    <button className="flex items-center transition duration-150 ease-in-out drop-rotate pt-3" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat6" aria-expanded="false" aria-controls="collapsecat6">
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                            <input type="checkbox" id="ab13" />
                                                            <label htmlFor="ab13" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Stainless Steel</label>
                                                        </div>
                                                        <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                                    </button>
                                                    <li className="list-none pt-3">
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                            <input type="checkbox" id="ab14" />
                                                            <label htmlFor="ab14" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Cast Iron</label>
                                                        </div>
                                                    </li>
                                                    <li className="list-none pt-3">
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                            <input type="checkhandlePayloadbox" id="ab15" />
                                                            <label htmlFor="ab15" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Cellulosic</label>
                                                        </div>
                                                    </li>
                                                    <li className="list-none pt-3">
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                            <input type="checkbox" id="ab16" />
                                                            <label htmlFor="ab16" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Gouging and Cutting</label>
                                                        </div>
                                                    </li>
                                                    <li className="list-none pt-3">
                                                        <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                            <input type="checkbox" id="ab17" />
                                                            <label htmlFor="ab17" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Mild Steel General Purpose</label>
                                                        </div>
                                                    </li>
                                                </div>
                                                <button className="flex items-center transition duration-150 ease-in-out pt-3 drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat7" aria-expanded="false" aria-controls="collapsecat7">
                                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                        <input type="checkbox" id="ab18" />
                                                        <label htmlFor="ab18" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Wires and Fluxes</label>
                                                    </div>
                                                    <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                                </button>
                                                <button className="flex items-center transition duration-150 ease-in-out pt-3 drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat8" aria-expanded="false" aria-controls="collapsecat8">
                                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                        <input type="checkbox" id="ab19" />
                                                        <label htmlFor="ab19" className="consumbales pl-3 text-xs2 font-normal text-[#808285] text-left">Brazing Products</label>
                                                    </div>
                                                    <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                                </button>
                                            </div>
                                            <button className="transition duration-150 ease-in-out flex items-center pt-3.5 drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat9" aria-expanded="false" aria-controls="collapsecat9">
                                                <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                    <input type="checkbox" id="ab20" />
                                                    <label htmlFor="ab20" className="consumbales pl-3 text-xs2 font-bold text-[#808285]">Equipment</label>
                                                </div>
                                                <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                            </button>
                                            <button className="transition duration-150 ease-in-out flex items-center pt-3.5 drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat10" aria-expanded="false" aria-controls="collapsecat10">
                                                <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                                    <input type="checkbox" id="ab21" />
                                                    <label htmlFor="ab21" className="consumbales pl-3 text-xs2 font-bold text-[#808285]">Other Products</label>
                                                </div>
                                                <img src="images/dropdown-filled.svg" alt="icon" className="ml-1.5 drop-btn show" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pt-3 flex justify-end">
                                <button type="button" className="w-[75%] sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}

const mapStateToProps = (state) => {
    const { Products, FilterData } = state;
    return { Products, FilterData };
};
const mapDispatchToProps = {
    GetProductList: DistributorActions.ProductListing,
    handleSegments: DistributorActions.handleFiltersData,
    GetCartItems: DistributorActions.GetCartItems,
    handleFiltersData: DistributorActions.handleFiltersData,
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductsListing);
